import { type NodeV2 } from '@vedalib/editor'
import React from 'react'

import { AppMode } from 'services/Store/Project/enums'
import type { Block, IBlockMode } from 'services/Store/Project/types'

import { ResizeControlActionUiEnum } from '../enums'
import CoordResizeControl from './CoordResizeControl'

interface IAbsoluteChildrenControlsProps {
  mode: IBlockMode
  block: Block
  node: NodeV2
  selected: NodeV2[]
}

const AbsoluteChildrenControls: React.FC<IAbsoluteChildrenControlsProps> = ({
  block,
  mode,
  node,
  selected,
}) => {
  const isPro = mode.editorMode === AppMode.pro
  if (isPro) {
    return (
      <>
        <CoordResizeControl
          block={block}
          mode={mode}
          node={node}
          selected={selected}
          type={ResizeControlActionUiEnum.TOP_LEFT}
        />
        <CoordResizeControl
          block={block}
          mode={mode}
          node={node}
          selected={selected}
          type={ResizeControlActionUiEnum.TOP}
        />
        <CoordResizeControl
          block={block}
          mode={mode}
          node={node}
          selected={selected}
          type={ResizeControlActionUiEnum.TOP_RIGHT}
        />
        <CoordResizeControl
          block={block}
          mode={mode}
          node={node}
          selected={selected}
          type={ResizeControlActionUiEnum.RIGHT}
        />
        <CoordResizeControl
          block={block}
          mode={mode}
          node={node}
          selected={selected}
          type={ResizeControlActionUiEnum.BOTTOM_RIGHT}
        />
        <CoordResizeControl
          block={block}
          mode={mode}
          node={node}
          selected={selected}
          type={ResizeControlActionUiEnum.BOTTOM}
        />
        <CoordResizeControl
          block={block}
          mode={mode}
          node={node}
          selected={selected}
          type={ResizeControlActionUiEnum.BOTTOM_LEFT}
        />
        <CoordResizeControl
          block={block}
          mode={mode}
          node={node}
          selected={selected}
          type={ResizeControlActionUiEnum.LEFT}
        />
      </>
    )
  }

  return null
}

export default React.memo(AbsoluteChildrenControls)
